{
  "journalAudit.action.program.technology_change_propagated": "Programme: technology change propagated to inheriting projects"
}
